import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getVerseForPath } from '../lib/format';

function SiteFooter() {
    const location = useLocation();
    const verse = getVerseForPath(location.pathname);

    return (
        <>
            <div className="kjv-verse-bar">
                <div className="kjv-verse-inner">
                    <span className="kjv-verse-text">{verse.text}</span>
                    <span className="kjv-verse-ref">{verse.ref}</span>
                </div>
            </div>
            <footer className="site-footer" role="contentinfo">
                <div className="footer-inner">
                    <div className="footer-brand">
                        <strong>The Discerner</strong>
                        <br />
                        Orthodox laymen writing on agathology, ponerology &amp; sacred history
                    </div>
                    <nav className="footer-links" aria-label="Footer navigation">
                        <Link to="/about">About The Discerner</Link>
                        <Link to="/grading-system">The Grading System</Link>
                    </nav>
                </div>
            </footer>
        </>
    );
}

export default SiteFooter;
